import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { EntityConfigService } from "../services/entity-config-service";
import { AclService } from "../services/acl-service";

export function RLSelectCharacteristics() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/select-characteristics.html"),
        controllerAs: "scVM",
        controller: SelectCharacteristicsController,
        scope: {
            showSelectCharacteristicsOption: '=',
            charTypeID: '=charTypeId',
            templateID: '=templateId',
            onCharacteristicsSelected: '&?',
            onCancel: '&?',
            hideCharsForSync: '=?'
        },
        bindToController: true
    }
    return directive;
}

export class SelectCharacteristicsController {
    static $inject = ['$window', '$scope', 'notifyService', 'entityConfigService', "aclService"];
    charTypeID: number;
    templateID: number;
    selectedCharacteristics: Models.ICharacteristicMetaData[];
    templateChars: Models.ICharacteristicMetaData[];
    onCharacteristicsSelected: (event: { characteristics: Models.ICharacteristicMetaData[] }) => any;
    onCancel: () => any;
    showSelectCharacteristicsOption: boolean;
    hideCharsForSync: boolean;

    constructor(private $window: ng.IWindowService, $scope: ng.IScope, private notifyService: NotifyService, private entityConfigService: EntityConfigService, private aclService: AclService) {
        $scope.$watch(() => this.showSelectCharacteristicsOption, (newValue, oldValue) => {
            if (newValue) {
                this.getTemplateMetaData();
            }
        });
    }

    $onInit() {
        this.templateChars = [];
        this.selectedCharacteristics = [];
    }

    private getTemplateMetaData() {
        this.notifyService.startProgress();
        this.entityConfigService.getCharacteristicTemplate(this.charTypeID, this.templateID)
            .then((result) => {
                var tmd = result;
                var filterdChars: Array<Models.ICharacteristicMetaData> = [];

                if (this.hideCharsForSync) {
                    filterdChars = result.characteristicMetaDatas.filter(chr => chr.systemIndicator != -1);
                }
                else {
                    filterdChars = result.characteristicMetaDatas;
                }

                this.templateChars = _.filter(filterdChars, (cmd) => {
                    var targetAcl = Utils.AclUtil.getDataEntityAcl(tmd.charTypeID, tmd.template.templateGroupID, tmd.templateID, cmd.groupID, cmd.characteristicID);
                    // we want to show characteristics in this list even if they don't have Write permissions so that the user can view them for reference
                    return Utils.AclUtil.hasAccess(this.aclService.acls, targetAcl, Consts.AccessRight.Read);
                });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SelectCharacteristics() {
        if (this.onCharacteristicsSelected != null) {
            this.onCharacteristicsSelected({ characteristics: this.selectedCharacteristics });
        }
    }

    SelectCharacteristic(characteristic: Models.ICharacteristicMetaData) {
        this.selectedCharacteristics.push(characteristic);
    }

    RemoveSelectedCharacteristic(characteristic: Models.ICharacteristicMetaData) {
        _.remove(this.selectedCharacteristics, sc => sc.characteristicID == characteristic.characteristicID);
    }

    Cancel() {
        if (this.onCancel != null) {
            this.onCancel();
        }
    }
}
